import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { ApplicationStore, getModuleGroupByName, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { SOFTLINE_PERMISSION_LAGERKORREKTUR } from './lagerkorrektur.shared';
import { lagerkorrekturRoutes } from './lagerkorrektur.routes';

export const lagerkorrekturProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'lagerkorrektur',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#LAGERKORREKTUR.APP',
      description: '#LAGERKORREKTUR.APP_DESC',
      route: '/lagerkorrektur',
      icon: 'fa-regular fa-box-archive',
      permission: SOFTLINE_PERMISSION_LAGERKORREKTUR,
      group: getModuleGroupByName('Lager'),
    });
  }),
];

export function provideLagerkorrekturModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'lagerkorrektur',
        title: '#LAGERKORREKTUR.APP',
        description: '#LAGERKORREKTUR.APP_DESC',
        icon: 'fa-regular fa-box-archive',
        route: '/lagerkorrektur',
        permission: SOFTLINE_PERMISSION_LAGERKORREKTUR,
        group: getModuleGroupByName('Lager'),
      },
      withSoftAppsModuleRoutes({ app: lagerkorrekturRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/lager/lagerkorrektur',
        description: 'Lagerkorrekturen erfassen.',
      })
    ),
  ];
}
